export default {
	properties: [
		{
			text: 'Minimo',
			key: 'min',
			type: 'number',
		},
		{
			text: 'Maximo',
			key: 'max',
			type: 'number',
		},
		{
			text: 'Color',
			key: 'color',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Rango de pre importacion',
	plural_model_name_spanish: 'Rangos de pre importacion',
	create_model_name_spanish: 'Nuevo rango',
	text_delete: 'el',
}